import isAnchor from './validation/is-anchor';
import isIdentificator from './validation/is-identificator';

export const PROTOCOL_SCHEMES = {
  TEL: 'tel',
  EMAIL: 'email',
  ANCHOR: 'anchor',
  HTTP: 'http',
};

Object.freeze(PROTOCOL_SCHEMES);

const getURLProtocolScheme = (url) => {
  try {
    const link = new URL(url);
    const { protocol } = link;
    switch (protocol) {
      case 'tel:':
        return PROTOCOL_SCHEMES.TEL;
      case 'mailto:':
        return PROTOCOL_SCHEMES.EMAIL;
      case 'about:':
        return PROTOCOL_SCHEMES.ANCHOR;
      case 'http:':
      case 'https:':
        return PROTOCOL_SCHEMES.HTTP;
      default:
        return null;
    }
  } catch (_) {
    return isAnchor(url) || isIdentificator(url) ? PROTOCOL_SCHEMES.ANCHOR : null;
  }
};

export default getURLProtocolScheme;
